module.exports = __webpack_public_path__ + "images/feature/140903_wechat_2-8985a5f1ae56eaab2f554c2c6d427217.jpg";